import type { PortalToolHandlerResultPayload } from '@terra/shared-dto-chat-types';
import type { ExternalToolResultCoordinator } from '../external-tool-batch.types';
import { isForegroundChatWorkSuppressed } from '../terminal-resume-suppress';

export function dropSuppressedForegroundExecute({
  coordinator,
  batchId,
  toolCallId,
  toolName,
  abortResult,
  chatId,
  sessionId,
  isSessionSuppressed,
}: {
  coordinator: Pick<ExternalToolResultCoordinator, 'completeRequest'>;
  batchId: string;
  toolCallId: string;
  toolName: string;
  abortResult: PortalToolHandlerResultPayload;
  chatId?: string;
  sessionId: string;
  isSessionSuppressed: (sessionId: string) => boolean;
}): boolean {
  if (
    !isForegroundChatWorkSuppressed({ chatId, sessionId }) &&
    !isSessionSuppressed(sessionId)
  ) {
    return false;
  }

  void coordinator
    .completeRequest({
      batchId,
      chatId: chatId ?? sessionId,
      toolCallId,
      toolName,
      status: 'error',
      result: abortResult,
    })
    .catch((error: unknown) => {
      console.warn(
        'Failed to record a stopped foreground tool result; the batch may flush without it',
        {
          error: error instanceof Error ? error : new Error(String(error)),
        },
      );
    });

  return true;
}

export function handshakeFailureKind(
  result: 'declared' | 'expected' | 'timedOut' | 'aborted',
): 'timeout' | 'abort' | undefined {
  if (result === 'timedOut') {
    return 'timeout';
  }

  if (result === 'aborted') {
    return 'abort';
  }

  return undefined;
}
